<template>
  <div class="dashboard-page">
    <Navbar />
    <div class="app-container">
      <Sidebar />
      <div id="main-content" class="main-content" :class="{ 'mobile-content': isMobile }" tabindex="-1">
        <a
          id="accesskey-c"
          href="#accesskey-c"
          accesskey="C"
          class="accesskey-brick sr-only-focusable"
          title="主要內容區塊，快捷鍵：Alt+C"
          aria-label="主要內容區塊"
        >:::</a>
        <div class="dashboard-content">
          <div class="welcome-section">
            <h1>{{ t("profileEdit.title") }}</h1>
            <p>{{ t("profileEdit.welcome") }}</p>
          </div>
          <a-card class="profile-form-card" :bordered="false">
            <a-tabs v-model:activeKey="activeTab" class="profile-tabs">
              <a-tab-pane key="profile" tab="基本資料">
                <div class="tab-content-wrapper">
                  <ProfileForm mode="edit" />
                </div>
              </a-tab-pane>
              <a-tab-pane key="security" tab="安全與密碼變更">
                <div class="tab-content-wrapper">
                  <ChangePasswordForm />
                </div>
              </a-tab-pane>
            </a-tabs>
          </a-card>
        </div>
      </div>
    </div>
    <FooterSection />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import Navbar from "../components/Navbar.vue";
import Sidebar from "../components/Sidebar.vue";
import FooterSection from "../components/FooterSection.vue";
import ProfileForm from "../components/ProfileForm.vue";
import ChangePasswordForm from "../components/ChangePasswordForm.vue";

const { t } = useI18n();
const route = useRoute();
const isMobile = ref(window.innerWidth <= 768);
const activeTab = ref(route.query.tab === "security" ? "security" : "profile");

watch(
  () => route.query.tab,
  (newTab) => {
    if (newTab === "security") {
      activeTab.value = "security";
    } else if (newTab === "profile") {
      activeTab.value = "profile";
    }
  }
);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style scoped>
.dashboard-page {
  min-height: 100vh;
  background: #f9f9f9;
}

.app-container {
  display: flex;
  min-height: calc(100vh - 58px);
  margin-top: 58px;
}

.main-content {
  flex: 1;
  padding: 32px;
  overflow-y: auto;
  height: calc(100vh - 58px);
}

.mobile-content {
  padding: 16px;
}

.dashboard-content {
  max-width: 980px;
  margin: 0 auto;
}

.welcome-section h1 {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
}

.welcome-section p {
  margin: 0 0 24px 0;
  color: #797979;
}

.profile-form-card {
  border-radius: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.tab-content-wrapper {
  padding-top: 12px;
}

.profile-tabs :deep(.ant-tabs-tab) {
  font-size: 16px;
  font-weight: 500;
  padding: 12px 20px;
}

.profile-tabs :deep(.ant-tabs-tab-active .ant-tabs-tab-btn) {
  color: var(--color-primary, #022964);
  font-weight: 600;
}

.profile-tabs :deep(.ant-tabs-ink-bar) {
  background-color: var(--color-primary, #022964);
}

@media (max-width: 1440px) {
  .dashboard-content {
    margin: 0 0 0 auto;
  }
}

@media (max-width: 1280px) {
  .dashboard-content {
    max-width: calc(100% - 220px);
  }
}

@media (max-width: 768px) {
  .dashboard-content {
    margin: 0 auto;
    max-width: 100%;
  }
}
</style>
